import { FC } from "react";
import { IconWrapper } from "../IconWrapper";
import { IconProps } from "../Icons.types";

const SuiLogo: FC<IconProps> = (allProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName="SuiLogo"
      icon={
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="13" viewBox="0 0 10 13" fill="none" {...props}>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M8.0019 5.42137C8.52328 6.08716 8.83505 6.92917 8.83505 7.8451C8.83505 8.76103 8.5138 9.62875 7.97872 10.2983L7.93238 10.3561L7.92027 10.2827C7.90973 10.2206 7.89762 10.1574 7.8834 10.0942C7.61534 8.89654 6.74215 7.86974 5.30493 7.0379C4.33432 6.47764 3.7787 5.80381 3.63282 5.03733C3.53855 4.54187 3.60859 4.04427 3.74394 3.61791C3.87929 3.19209 4.08047 2.83482 4.25163 2.62003L4.81093 1.92479C4.90889 1.80266 5.09269 1.80266 5.19065 1.92479L8.00242 5.42137H8.0019ZM8.88614 4.72667L5.13851 0.0666858C5.06688 -0.0222286 4.93312 -0.0222286 4.86149 0.0666858L1.11439 4.72667L1.10228 4.7422C0.412892 5.61259 0 6.71867 0 7.92276C0 10.7268 2.23878 13 5 13C7.76122 13 10 10.7268 10 7.92276C10 6.71867 9.58711 5.61259 8.89772 4.74273L8.88561 4.7272L8.88614 4.72667ZM2.01127 5.40637L2.34622 4.98912L2.35623 5.06626C2.36412 5.12732 2.37413 5.18838 2.38572 5.24998C2.6027 6.40747 3.3774 7.37214 4.67242 8.11934C5.7984 8.7712 6.45408 9.52055 6.64262 10.3422C6.72161 10.685 6.73531 11.0225 6.70107 11.3176L6.69897 11.3358L6.68264 11.3438C6.17443 11.5961 5.60301 11.7381 4.99947 11.7381C2.88182 11.7381 1.16495 9.99512 1.16495 7.84456C1.16495 6.92114 1.48146 6.07323 2.01022 5.4053L2.01127 5.40637Z" fill="#202124"/>
        </svg>
      }
      {...restProps}
    />
  );
};

export default SuiLogo;
